import { Component, Input, OnInit } from '@angular/core';
import { Message } from '../../../../classes/Message';
import { CustomerService } from '../../../../services';
import { MessageService } from 'primeng';
import { ICustomerProfileActivity } from '../../../../interfaces/telephony/customer/customer-profile-activity.interface';

@Component({
  selector: 'app-customer-profile-activity',
  templateUrl: './customer-activity.component.html',
  styleUrls: ['./customer-activity.component.scss', '../customer-information.component.scss'],
})
export class CustomerActivityComponent implements OnInit {
  constructor(private customerService: CustomerService, private messageService: MessageService) {}

  private _customerId: number;
  @Input()
  get customerId(): number {
    return this._customerId;
  }

  set customerId(value: number) {
    if (this._customerId !== value) {
      this._customerId = value;
      this.loadInformation();
    }
  }

  activity: ICustomerProfileActivity;
  isBusy = false;

  ngOnInit() {}

  loadInformation() {
    this.isBusy = true;

    this.customerService
      .getProfileActivity(this.customerId)
      .then((info) => {
        this.activity = info;
        this.isBusy = false;

        console.log('Loaded customer activity: ', info);
      })
      .catch((err) => {
        this.messageService.add(
          Message.Error('Load Customer Activity', 'An error occurred loading customer activity'),
        );
        this.isBusy = false;
      });
  }
}
